module.exports = __webpack_public_path__ + "img/martial-arts.e1e96d51.svg";